"use client";
import { Shield, Zap, Maximize, Layers, Activity, Cpu, Eye, Lock } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { benefits as data } from "@/lib/data/platform-architecture";

const iconMap: Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties }>> = {
  Shield, Zap, Maximize, Layers, Activity, Cpu, Eye, Lock,
};

export function Benefits() {
  return (
    <Section id="benefits" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-emerald)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
          </div>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {data.benefits.map((b, i) => {
            const Icon = iconMap[b.icon] ?? Shield;
            return (
              <Reveal key={b.title} delay={i * 50}>
                <div className="glass rounded-2xl p-5 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, var(--color-${b.accent}) 12%, transparent)` }}>
                  <span
                    className="grid place-items-center h-10 w-10 rounded-lg"
                    style={{
                      background: `color-mix(in oklch, var(--color-${b.accent}) 18%, transparent)`,
                      boxShadow: `inset 0 0 0 1px color-mix(in oklch, var(--color-${b.accent}) 35%, transparent)`,
                    }}
                  >
                    <Icon className="h-4 w-4" style={{ color: `var(--color-${b.accent})` }} />
                  </span>
                  <h3 className="mt-3 text-base">{b.title}</h3>
                  <p className="mt-2 text-xs text-[rgb(var(--fg-muted))] leading-relaxed">{b.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </Section>
  );
}
